// Reference: https://mui.com/material-ui/customization/theming/

export const themeLight = {
	palette: {
		mode: "light",
		divider: "#000000",
		background: {
			default: "#e4ebee",
			paper: "#ffffff",
			contrastText: "#232323",
		},
		text: {
			primary: "#232323",
			secondary: "#333333",
			disabled: "#5B5B5B",
		},
		action: {
			active: "#232323",
			hover: "rgba(0, 0, 0, 0.04)",
			hoverOpacity: 0.04,
			selected: "rgba(0, 0, 0, 0.08)",
			selectedOpacity: 0.08,
			disabled: "rgba(0, 0, 0, 0.26)",
			disabledBackground: "rgba(0, 0, 0, 0.12)",
			disabledOpacity: 0.38,
			focus: "rgba(0, 0, 0, 0.12)",
			focusOpacity: 0.12,
			activatedOpacity: 0.12,
		},
	},
};
